export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/spoof-medium-64bebd3755729b957ebdb06da256a613.woff2";